import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Business from "./Business";
import Testimonial from "./Testimonial";

export default function CapitalMarket() {


    return (
        <>
            <div className="aboutus_bg" >
                <div className="aboutus-img-content">
                    <h1>Capital Markets</h1>
                </div>
            </div>

          
            <Container className="it-overview mt-5 mb-5" >
                {/* <h6>OVERVIEW</h6> */}
                <h3 className="text-center" style={{ color: '#0e2b5c', paddingBottom: '15px' }}>Driving Growth with Smarter Investments</h3>
                <div className="overview-container" style={{ padding: '0 12%', color: '#627792', fontSize: '18px', fontWeight: '500', lineHeight: '1.8' }}>
                    <p >Capital markets demand speed, precision, and insight. Our solutions enable firms to automate trading, optimize risk management, and gain deep market intelligence for better investment decisions. We provide algorithmic trading tools, portfolio analytics, and risk mitigation strategies that give investors a competitive edge. By integrating AI and machine learning, we help financial institutions predict market trends and drive higher returns.
                    </p>
                </div>
            </Container>

           

            {/**benefit */}

            <section className="py-5 text-light mb-5" style={{ backgroundColor: "#141b29" }} >
                {/* <h6 className="text-uppercase text-center text-info mb-2">Benefits to Capital Markets on</h6> */}
                <h2 className="text-center mb-5">Our Solutions for Capital Markets
                </h2>
                <Container>
                    <Row>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>High-frequency trading solutions for faster transactions</h5>
                                <p>Automated and algorithm-driven trading ensures lightning-fast transactions, giving traders a competitive edge in volatile markets. By reducing manual intervention and latency, our solutions maximize profitability and optimize trade execution strategies. Scalability and real-time processing ensure seamless operations even in high-volume trading environments.
                                Stay ahead in volatile markets with cutting-edge automation and real-time execution strategies.
                                </p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Risk analytics & compliance tools for smarter investments</h5>
                                <p>Leverage AI-driven models to assess market risks, regulatory compliance, and investment exposure in real time. Our advanced analytics help financial firms mitigate losses, identify potential threats, and make data-driven investment decisions with confidence. Built-in regulatory frameworks ensure firms stay compliant with evolving financial regulations worldwide.
                                Ensure financial security and regulatory adherence with AI-driven risk assessment and compliance solutions.
                                </p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Advanced data visualization for real-time market insights</h5>
                                <p>Transform complex financial data into actionable intelligence with dynamic dashboards and real-time analytics. Our intuitive visualization tools enable traders and analysts to track trends, detect anomalies, and make informed investment decisions instantly. Customizable interfaces and interactive reports provide deeper insights tailored to unique trading strategies.
                                Gain a competitive edge with intuitive dashboards that translate financial data into actionable intelligence.
                                </p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>AI-powered sentiment analysis for market predictions</h5>
                                <p>Monitor financial news, social media trends, and investor sentiment using natural language processing (NLP). By analyzing market psychology and public perception, our AI-driven tools provide predictive insights that help traders anticipate market movements and optimize investment strategies. Multi-source aggregation ensures comprehensive market analysis by integrating data from diverse global channels.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </section>

            <Business />
        </>
    )
}